import { FC, useEffect, useState } from 'react';

import Link from 'next/link';

import { Box, Card, Grid, Typography } from '@mui/material';

import { useQuery } from 'react-query';

import { useChatRooms } from '@hooks_iqfu/chat/useChatRoom';

import { CompanySellerRoomItem } from '@type-def_iqfu/chat/CompanySellerRoomItem';

import {
  conversionStyle,
  NoticeEmphasisMessageStyle,
  NoticeMessageStyle,
  NoticeStyle,
  NoticeTitleStyle,
  titleStyle,
} from './DashboardInfoCardStyles';
import SellingConsultationInfo from './SellingConsultationInfo';

type Props = {};

const DashboardInfoCard: FC<Props> = () => {
  const { getCompanySellerChatRoomList } = useChatRooms();
  const [chatRooms, setChatRooms] = useState<CompanySellerRoomItem[]>([]);

  const { data: fetchedRoomsData, isSuccess } = useQuery(['companySellerRoomList'], ({ pageParam = 0 }) =>
    getCompanySellerChatRoomList({
      offset: pageParam,
    }),
  );

  useEffect(() => {
    if (fetchedRoomsData)
      setChatRooms(fetchedRoomsData.chat_rooms.filter((e: CompanySellerRoomItem) => e.unread || !e.has_started));
  }, [fetchedRoomsData]);

  return (
    <Card sx={{ mt: 2, p: 2 }}>
      <SellingConsultationInfo chatRooms={chatRooms} />
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <Typography sx={titleStyle}>媒介契約報告</Typography>
          <Typography sx={conversionStyle}>
            イクラ不動産よりご紹介した顧客様と
            <br />
            媒介契約(媒介更新を含む)を結んだら…
          </Typography>
          <Typography sx={conversionStyle}>
            <Link href={`/console/company/chat/mediation_agreement_reports/create`}>
              <a style={{ color: '#3D5DA2', fontSize: '2rem', textDecoration: 'underline' }}>媒介契約報告</a>
            </Link>
            からご報告が必要です
          </Typography>
          <Box sx={NoticeStyle}>
            <Typography sx={NoticeTitleStyle}>※注意事項※</Typography>
            <Typography sx={NoticeMessageStyle}>
              媒介契約を結ばれた際は、契約締結後
              <Typography component="span" sx={NoticeEmphasisMessageStyle}>
                「1週間以内」
              </Typography>{' '}
              に契約書のアップロードが必要です
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography sx={titleStyle}>売買契約報告</Typography>
          <Typography sx={conversionStyle}>
            イクラ不動産よりご紹介した顧客様と
            <br />
            売買契約を結んだら…
          </Typography>
          <Typography sx={conversionStyle}>
            <Link href={`/console/company/chat/agreement_reports/create`}>
              <a style={{ color: '#3D5DA2', fontSize: '2rem', textDecoration: 'underline' }}>売買契約報告</a>
            </Link>
            からご報告が必要です
          </Typography>
          <Box sx={NoticeStyle}>
            <Typography sx={NoticeTitleStyle}>※注意事項※</Typography>
            <Typography sx={NoticeMessageStyle}>
              売買契約を結ばれた際は、契約締結後
              <Typography component="span" sx={NoticeEmphasisMessageStyle}>
                「1週間以内」
              </Typography>{' '}
              に契約書のアップロードが必要です
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};

export default DashboardInfoCard;
